import { SxProps } from "@mui/material";

export const sxIconButton: SxProps = {
  color: '#383838',
}

export const sxTypography: SxProps = {
  marginRight: '8px'
}

export const sxListItemText: SxProps = {
  fontSize: 16
}

export const sxListItemButton: SxProps = {
  pl: 4
}

export const sxDivider: SxProps = {
  marginBottom: '40px'
}

export const sxDividerContrast: SxProps = {
  marginBottom: '40px',
  background: 'white'
}